<template>
  <div class="index-consultation">
    <comTop></comTop>
    <!-- <banner></banner> -->
    <div class="about_box_total">
      <div class="introduceCer_box_top">
        <el-row class="img_box">
          <el-col>
            <span class="span1">资讯中心</span>
          </el-col>
          <el-col>
            <span class="span2">Information Center</span>
          </el-col>
          <el-col>
            <div class="span3"></div>
          </el-col>
          <el-col>
            <div class="span4">扬海资产</div>
          </el-col>
          <el-col>
            <el-row type="flex" justify="space-between">
              <el-col :span="18">投资管理有限公司</el-col>
              <el-col :span="6">
                <div class="page_spirit_bom_btn">
                  <el-button @click="contact">联系我们 ⇀</el-button>
                </div>
              </el-col>
            </el-row>
          </el-col>
          <el-col>
            <div class="about_wenzi">
              我司是一家专业的不良资产处置公司，专注于为金融行业提供不良资产处置服务。公司拥有雄厚的资金实力和专业的催收团队，具备丰富的行业经验，公司秉承“扬帆起航，海纳百川”的企业宗旨，面向全国，立足长远，致力于成为行业领先的不良资产综合服务平台。
              <br />自2017年以来我司积极响应国家号召用实际行动化解坏账风险，落实银保监会的精神要求，主动承担资产公司化解金融风险、维护金融稳定的功能和职责。自成立以来已累计服务上百万逾期用户，协助用户规划合理的还款计划并实现最终还款。
              <br />展望未来，我司将立足国家对金融资产管理公司的功能定位，围绕不良资产主责主业，服务实体经济、防控金融风险、深化改革转型，打造可持续发展的商业模式，实现建设高质量发展新扬海目标。
              <br />
            </div>
          </el-col>
          <el-col>
            <el-row>
              <el-col>
                <div class="page_spirit_bom_img_new">
                  <div class="page_spirit_bom_flex_new">
                    <img src="../../assets/img/ico-gaoxiao.png" alt />
                    <span>专业</span>
                  </div>
                  <div class="page_spirit_bom_border_new"></div>
                  <div class="page_spirit_bom_flex_new">
                    <img src="../../assets/img/ico-gaoxiao.png" alt />
                    <span>创新</span>
                  </div>
                  <div class="page_spirit_bom_border_new"></div>
                  <div class="page_spirit_bom_flex_new">
                    <img src="../../assets/img/ico-gaoxiao.png" alt />
                    <span>诚信</span>
                  </div>
                </div>
              </el-col>
            </el-row>
          </el-col>
        </el-row>
      </div>
    </div>
    <comFooterMobile></comFooterMobile>
    <div class="index-about_about">
      <div class="about_box">
        <el-row>
          <el-col :span="6">
            <div class="about_box_left">
              <div class="introduceCer_box_top_new">
                <el-row>
                  <el-col>
                    <span class="span1">资讯中心</span>
                  </el-col>
                  <el-col>
                    <span class="span2">Information Center</span>
                  </el-col>
                  <el-col>
                    <div class="introduceCer_box_top_border_new"></div>
                  </el-col>
                  <el-col>
                    <span class="span3">扬海资产</span>
                  </el-col>
                  <el-col>
                    <span class="span4"></span>
                  </el-col>
                  <el-col>

                  </el-col>
                  <el-col class="introduceCer_box_content">
                    <div class="introduceCer_box_top_btn" style="padding:10px 0">
                      <el-button @click="changePage(chartBox)">媒体聚焦 ⇀</el-button>
                    </div>
                    <div class="introduceCer_box_top_btn" style="padding:10px 0">
                      <el-button @click="changePage(tableBox)">公告通知 ⇀</el-button>
                    </div>
                  </el-col>
                </el-row>
              </div>
            </div>
          </el-col>
          <el-col :span="16" class="not_eng_item_box">
              <component :is="currentView"></component>
          </el-col>
           <el-col :span="2">

          </el-col>
        </el-row>
      </div>
    </div>
    <comFooter></comFooter>
  </div>
</template>
<script>
// import getTimestamp from "./../../assets/js/time";
import comTop from "@/components/page/comTop.vue"; //头部
import comFooter from "@/components/page/comFooter.vue"; //脚部
import banner from "@/components/page/banner.vue"; //脚部
import comFooterMobile from "@/components/page/comFooterMobile.vue"; //脚部
import aa from "@/components/page/aa.vue";
import bb from "@/components/page/bb.vue"; 
export default {
  components: {
    comFooter,
    comTop,
    banner,
    comFooterMobile,
    aa,
    bb
  },
  data() {
    return {
      currentView : 'aa',
      chartBox: 'aa',
      tableBox: 'bb',
    };
  },
  computed: {},
  watch: {},
  methods: {
    changePage(path){
      this.currentView = path;
    },
    contact(){
      let that = this;
      that.$router.push({name:'contact'})
    }
  },
  created(){
    
  }  
};
</script>

<style>
@media screen and (min-width: 300px) and (max-width: 480px) {
  /* .page_spirit_bom_btn {
    border: 2px solid #dcdfe6;
  } */
  .about_box_total .about_wenzi {
    line-height: 50px;
    font-size: 12px;
  }
  .page_spirit_bom_img_new {
    display: flex;
    justify-content: space-around;
  }
  .index-about .banner-box {
    display: block !important;
  }
  .index-about .introduceTop {
    display: none;
  }
  .index-about_about {
    display: none !important;
  }
  .index-footer {
    display: none !important;
  }
  .introduceCer_box_top {
    padding: 40px 20px;
    background: #fff;
  }
  .introduceCer_box_top .span1 {
    font-size: 45px;
    font-family: Helvetica;
    color: rgba(34, 34, 34, 1);
    line-height: 45px;
  }
  .introduceCer_box_top .span2 {
    font-size: 20px;
    font-family: Helvetica;
    color: rgba(0, 0, 0, 1);
    line-height: 20px;
  }
  .introduceCer_box_top .span3 {
    width: 350px;
    height: 2px;
    background: rgba(34, 34, 34, 1);
    margin-bottom: 100px;
  }
  .about_box_total {
    display: block !important;
  }
  .index-comFooterMobile {
    display: block !important;
  }
}
.about_box_total {
  display: none;
}
.index-comFooterMobile {
  display: none;
}
.index-about .banner-box {
  display: none;
}
.index-about_about {
  display: block;
}
.index-footer {
  display: block;
}
.index-consultation {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  overflow: auto;
}
.index-about_about {
  background: #ffffff;
}
.about_box {
  padding: 100px 100px 0 260px;
}
.page_spirit_bom_img {
  display: flex;
  justify-content: space-between;
  width: 480px;
  padding: 64px 0;
}
.page_spirit_bom_flex {
  display: flex;
  flex-direction: column;
  align-items: center;
}
.page_spirit_bom_img_new .page_spirit_bom_border_new {
  width: 2px;
  height: 95px;
  background: rgba(34, 34, 34, 1);
}
.introduceCer_box_top_new .span1 {
  font-size: 45px;
  font-family: MicrosoftYaHeiSemibold;
  color: rgba(34, 34, 34, 1);
  line-height: 45px;
}
.introduceCer_box_top_new .span2 {
  font-size: 20px;
  font-family: MicrosoftYaHei;
  color: rgba(0, 0, 0, 1);
  line-height: 20px;
  padding: 15px 0 40px 0;
  display: inline-block;
}
.introduceCer_box_top_new .span3 {
  font-size: 36px;
  font-family: MicrosoftYaHeiSemibold;
  color: rgba(0, 0, 0, 1);
  line-height: 36px;
  display: inline-block;
}
.introduceCer_box_top_new .span4 {
  font-size: 26px;
  font-family: MicrosoftYaHei;
  color: rgba(0, 0, 0, 1);
  line-height: 26px;
  padding: 15px 0 60px 0;
  display: inline-block;
}
.introduceCer_box_top_new .introduceCer_box_top_border_new {
  width: 350px;
  height: 1px;
  background: rgba(34, 34, 34, 1);
  margin-bottom: 30px;
}

.introduceCer_box_top_btn .el-button {
  width: 170px;
  height: 50px;
  background: rgba(255, 255, 255, 0.1);
  border: 1px solid rgba(34, 34, 34, 1);
}
.about_box_right .span1 {
  font-size: 18px;
  font-family: MicrosoftYaHei;
  color: rgba(0, 0, 0, 1);
  line-height: 38px;
}
.about_box_right .span2 {
  font-size: 28px;
  font-family: MicrosoftYaHeiSemibold;
  color: rgba(0, 0, 0, 1);
  margin: 80px 0 40px 0;
  display: inline-block;
}
.page_spirit_bom_flex {
  display: flex;
  flex-direction: column;
  align-items: center;
}
.not_eng_item_box{
    /* display: flex;
    justify-content: space-around;
    flex-wrap: wrap; */
}
/* .not_eng_item img{
  width: 310px;
  height: 185px;
} */
.not_eng_item .p2{
  font-size:18px;
  font-family:Helvetica;
  color:rgba(0,0,0,1);
  line-height:22px;
}
.index-consultation .index-footer {
  background: #fff;
  border-top: rgba(34, 34, 34, 0.1) solid 1px;
 /* position: absolute; */
    bottom: 0;
    width: 100%;
}
.introduceCer_box_content{
  padding: 100px 0;
}
</style>


// WEBPACK FOOTER //
// src/components/page/consultation.vue